import { render, staticRenderFns } from "./FormTipo.vue?vue&type=template&id=042f5802"
import script from "./FormTipo.vue?vue&type=script&lang=js"
export * from "./FormTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports